
function Loader() {
  return (
    <div className="w-full h-full  flex justify-center items-center">
      <div className="absolute flex my-auto w-8 h-8 rounded-full animate-spin border-[4px] border-solid  border-b-transparent"></div>
    </div>
  );
}
export default Loader;
